export default {
  ESI_WILD: 1,
  ESI_KALYNA: 2,
  ESI_SABER: 3,
  ESI_ROOSTER: 4,
  ESI_PALYANYTSYA: 5,
  ESI_PYSANKA: 6,
  ESI_WHEAT: 7,
  ESI_SCATTER: 8,
}
